module.exports = __webpack_public_path__ + "img/company-logo.9d9e556e.svg";